<!-- Toolbar -->
<div class="toolbar" role="banner">
<!--  <img style="width: 9%; min-width: 70px" alt="Vida security Logo" src="../assets/images/logo.svg" />-->
  <img style="width: 9%; min-width: 70px" alt="Vida security Logo" src="http://www.colegiomedico.cl//wp-content/uploads/2018/08/logo_colmed_horizontal.png" />
  <span style="min-width: 120px">Inscripción Seguro Colectivo Colegio Médico</span>
</div>
<div class="main">
  <router-outlet></router-outlet>
</div>
